import { LitElement, html, svg } from 'lit';

export class IconBankId32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>BankId logo</title><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M2 7h5M25 7h5M25 13h5M25 25h5M2 25h5M2 19h5M14 19h5M14 13h5"></path></svg>`; }
}
if (!customElements.get('f-icon-bank-id32', IconBankId32)) {
  customElements.define('f-icon-bank-id32', IconBankId32);
}